export default {
    common: {
      loading: 'Loading...',
      noData: 'No product data available.',
    },
    nav: {
      home: 'Home',
      products: 'Product',
      solutions: 'Solution',
      about: 'About Us',
      partnership: 'Partnership',
      blog: 'Blog',
    },
    home: {
      text: 'HOME',
      title: 'YOOXPLORE',
      hero: {
        title1: 'Empowering Global Partners',
        title2: 'Securing the Future from Above',
        bookDemo: 'Book A Demo',
      },
    },
    overview: {
      title: 'Overview',
      subtitle: 'YOOX S3T UAV Platform',
      content: 'YOOX S3T is an advanced unmanned aerial vehicle (UAV) that can lift heavy loads, fly steadily, and move around very well. In fact, this drone was built to be one of the best autonomous drones on the market today. In addition, it has a long flight time and great long-range performance. Because of this, this high-tech drone is great for military operations, industrial tasks, and humanitarian missions. As a result, it can be used in a lot of different ways to meet the needs of different industries’ requirements.',
      content2: 'We sell drones, and at the same time, we hope to help your drone brand succeed locally. We provide localized production and assembly solutions for drones, helping you to build your own production system in your own place and be able to produce the best drones on your own to achieve your goals.',
    },
    scenarios: {
      title: 'Scenarios',
      subtitle: 'Expandable to more industry use cases',
    },
    advantages: {
      title: 'Core Advantages',
      subtitle: 'Designed to scale with your requirements',
    },
    products: {
      title: 'Product Center',
      intro: 'Product Introduction',
      subtitle: 'Industry-level Flying Platform and Ecological Products',
      gallery: {
        all: 'All',
      },
      contact_business: 'Please contact us for more product details',
      tab: {
        introduce: 'Introduce',
        specs: 'Specs',
        faqs: 'FAQs',
        videos: 'Videos',
      },
    },
    solutions: {
      title: 'Solutions',
      intro: 'Solution Introduction',
      subtitle: 'Industry Solutions and Delivery Capabilities',
      gallery: {
        all: 'All',
      },
      contact_business: 'Please contact us for more solution details',
      noData: 'No solution data available.',
    },

    about: {
      text: 'About Us',
      title: 'About Us',
      teamTitle: 'Our Team',
      teamSubtitle: 'From leading global companies',
      teamContent: 'Our team comes from companies including DJI, Yamaha, Apple, Tesla, etc. We have an average of over ten years of experience in the drone industry, as well as in the fields of security and military.',
      visionTitle: 'Our Vision',
      visionSubtitle: 'Help your drone brand succeed locally',
      visionContent: 'We sell drones, and at the same time, we provide localized production and assembly solutions for drones, helping you to build your own production system in your own place and be able to produce the best drones on your own to achieve your goals.',
    },
    partnership: {
      title: 'Partnership',
      primaryCta: 'Wholesale & ODM & OEM',
      secondaryCta: 'Become a Dealer',
      qaTitle: 'Q&A',
    },
    blog: {
      title: 'Blog',
      heading: 'Insights & Updates',
      subheading: 'The latest on drones, localization, and market trends.',
      searchPlaceholder: 'Search articles',
    },
    contact: {
      title: 'Contact Us',
      title2: 'We’d love to hear from you.',
      content1: 'If you want to know more information or cooperate with us, please contact us via WhatsApp, Telegram, or the form.',
      whatsappLabel: 'WhatsApp',
      whatsappValue: 'WhatsApp: <YOUR_WHATSAPP>',
      telegramLabel: 'Telegram',
      telegramValue: 'Telegram: <YOUR_TELEGRAM>',
      form: {
        title: 'Contact Form',
        subtitle: 'We’d love to hear from you.',
        firstName: 'First Name',
        lastName: 'Last Name',
        email: 'Email',
        phone: 'Phone',
        company: 'Company',
        country: 'Country/Region',
        interestLabel: 'I am interested in',
        interests: ['Product purchase', 'Become a dealer', 'OEM/ODM', 'Technical consultation', 'Other'],
        message: 'Your needs & description',
        submit: 'Submit',
        submitTip: 'Thanks for reaching out. We will get back to you shortly.',
        submitError: 'Submit failed. Please try again.',
      },
    },
    notFound: {
      exclamation: 'Oh!',
      message: "Looks like this page doesn't exist",
      cta: 'Get me Out of Here',
      metaTitle: 'Oops! No Page Found',
    },
    related: {
      title: 'Related',
    },
}
